/* ===== EN Cart-Drawer/Cart JS — global, läuft auf Seitenload ===== */
(function () {
  if (window.__enCartInit) return;
  window.__enCartInit = 1;

  function money(cents, sum) {
    try { if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, sum.getAttribute('data-money-format')); } catch (e) {}
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function updateShipping(sum) {
    var total = parseInt(sum.getAttribute('data-cart-total'), 10);
    if (isNaN(total)) return;
    var threshold = parseInt(sum.getAttribute('data-free-threshold'), 10);
    if (isNaN(threshold)) threshold = 3500;
    var flat = parseInt(sum.getAttribute('data-flat-rate'), 10);
    if (isNaN(flat)) flat = 380;
    var ship = total >= threshold ? 0 : flat;
    var shipEl = sum.querySelector('[data-ship-amount]');
    var totEl = sum.querySelector('[data-grand-total]');
    // NUR schreiben, wenn sich der Wert ändert. Sonst würde jeder Schreibzugriff eine Mutation
    // im beobachteten Bereich auslösen → MutationObserver feuert → runShipping → Endlosschleife.
    if (shipEl) {
      var newShip = (ship === 0) ? '<strong>Gratis</strong>' : money(ship, sum);
      if (shipEl.innerHTML !== newShip) shipEl.innerHTML = newShip;
    }
    if (totEl) {
      var newTot = money(total + ship, sum);
      if (totEl.textContent !== newTot) totEl.textContent = newTot;
    }
  }
  function runShipping() {
    var nodes = document.querySelectorAll('[data-cart-summary-ship]');
    for (var i = 0; i < nodes.length; i++) updateShipping(nodes[i]);
  }

  /* ---- Rabatt-Feedback ---- */
  function discMsg(box, text, isError) {
    if (!box) return;
    var msg = box.parentNode.querySelector('.en-disc-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'en-disc-msg';
      msg.style.cssText = 'font-size:1.2rem;line-height:1.35;margin-top:7px;';
      box.parentNode.insertBefore(msg, box.nextSibling);
    }
    msg.textContent = text;
    msg.style.color = isError ? '#c0392b' : '#0a7d2c';
  }
  function clearDiscMsg(box) {
    if (!box) return;
    var msg = box.parentNode.querySelector('.en-disc-msg');
    if (msg) msg.textContent = '';
  }

  /* Drawer in-place aktualisieren — gibt false zurück, wenn kein Drawer da ist (z.B. /cart-Seite).
     WICHTIG: #CartDrawer-Body wird NICHT als Element ersetzt. body-scroll-lock (iOS: position:fixed +
     element-gebundene touchmove-Handler) hält eine Referenz auf #CartDrawer-Body; würde man es austauschen,
     gibt close() den Body-Scroll nicht mehr frei → Seite friert ein (v.a. iOS). Deshalb nur die INHALTE
     der relevanten Bereiche angleichen und das Body-Element behalten. */
  function refreshDrawer(sections) {
    var cur = document.querySelector('#CartDrawer');
    if (!cur || !sections || !sections['cart-drawer']) return false;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('#CartDrawer');
    if (!fresh) return false;
    function syncInner(sel) {
      var c = cur.querySelector(sel), f = fresh.querySelector(sel);
      if (c && f && c.innerHTML !== f.innerHTML) c.innerHTML = f.innerHTML;
    }
    syncInner('#CartDrawer-Body');            // Element bleibt erhalten → Scroll-Lock-Referenz bleibt gültig
    syncInner('.cart-drawer__summary');
    syncInner('.cart-drawer__head');
    syncInner('.cart-drawer__shipping-bar');
    runShipping();
    document.dispatchEvent(new CustomEvent('en:cart-updated'));
    return true;
  }

  /* Global: Rabatt anwenden + Sticky-Drawer SOFORT aktualisieren — für den PDP-„Code kopieren"-Button.
     Nutzt /cart/update.js (setzt den Rabatt sofort im Warenkorb UND liefert die frische cart-drawer-Sektion),
     statt /discount/CODE (das aktualisierte den bereits gerenderten Drawer NICHT → Code erschien erst nach
     Checkout-Umweg). refreshDrawer aktualisiert den Drawer scroll-lock-sicher. */
  window.enApplyDiscount = function (code) {
    if (!code) return;
    if (!window.fetch) { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart'; return; }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code, sections: ['cart-drawer'], sections_url: '/' }),
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (!refreshDrawer(d.sections)) runShipping();
      document.dispatchEvent(new CustomEvent('en:cart-updated'));
    }).catch(function () {});
  };

  /* Rabatt anwenden/entfernen — mit Validierung + Feedback + korrektem UI-Refresh */
  function setDiscount(code, btn, box) {
    // Alt-Browser ohne fetch (uralt-Android/Safari): Rabatt per Server-Redirect einlösen — funktioniert überall
    if (!window.fetch) {
      if (code !== '') window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
      else window.location.href = '/cart';
      return;
    }
    if (btn) btn.disabled = true;
    clearDiscMsg(box);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code, sections: ['cart-drawer'], sections_url: '/' }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        // Entfernen: immer aktualisieren
        if (code === '') {
          if (!refreshDrawer(d.sections)) window.location.reload();
          return;
        }
        // Gültig? per frischem /cart.js prüfen (zuverlässige Titel)
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          var lc = code.toLowerCase();
          var applied = (cart.cart_level_discount_applications || []).some(function (x) {
            return (x.title || x.code || '').toLowerCase() === lc;
          });
          if (applied) {
            if (!refreshDrawer(d.sections)) window.location.reload();
          } else {
            discMsg(box, 'Code „' + code + '" ist ungültig oder abgelaufen.', true);
            if (btn) btn.disabled = false;
          }
        });
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        discMsg(box, 'Es gab ein Problem — bitte erneut versuchen.', true);
      });
  }

  function applyFrom(el) {
    var box = el.closest('[data-cart-discount]');
    if (!box) return;
    var inp = box.querySelector('[data-discount-input]');
    var code = inp ? inp.value.trim() : '';
    if (!code) { if (inp) inp.focus(); discMsg(box, 'Bitte einen Rabattcode eingeben.', true); return; }
    setDiscount(code, box.querySelector('[data-discount-apply]'), box);
  }

  document.addEventListener('click', function (e) {
    var ap = e.target.closest('[data-discount-apply]');
    if (ap) { e.preventDefault(); applyFrom(ap); return; }
    var rm = e.target.closest('[data-discount-remove]');
    if (rm) { e.preventDefault(); setDiscount('', rm, document.querySelector('[data-cart-discount]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-discount-input]')) {
      e.preventDefault(); applyFrom(e.target);
    }
  });

  function boot() { runShipping(); observe(); }
  var scheduled = false;
  var obs = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; runShipping(); }, 100);
  });
  function observe() {
    ['#CartDrawer', '#main-cart'].forEach(function (sel) {
      var t = document.querySelector(sel);
      if (t) obs.observe(t, { childList: true, subtree: true });
    });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
